import Page from '../../components/templates/Page'
import Welcome from '../../components/pages/blog/Welcome'
import Content from '../../components/pages/blog/Content'
import Subscribe from '../../components/pages/blog/Subscribe'
import SocialPromo from '../../components/pages/blog/SocialPromo'
import cache from 'memory-cache'
import headerTranslation from '/components/general/Header/headerTranslation'
import footerTranslation from '/components/general/Footer/footerTranslations'
import blogTranslation from '../../components/pages/blog/blogTranslations'
import { useRouter } from 'next/router'
import axios from '/components/configs/axios'

export const getStaticProps = async () => {
  let headerDataTranslation = cache.get('headerTranslations')
  if (!headerDataTranslation) {
    headerDataTranslation = await headerTranslation()
    cache.put('headerTranslations', headerDataTranslation)
  }

  // caching for footer translations
  let footerDataTranslation = cache.get('footerTranslations')
  if (!footerDataTranslation) {
    footerDataTranslation = await footerTranslation()
    cache.put('footerTranslations', footerDataTranslation)
  }

  let blogDataTranslation = await blogTranslation()

  const featuredBlogs = await axios
    .get('blog/post-featured')
    .then((res) => res.data)

  const allPosts = await axios.get('blog/posts').then((res) => res.data)

  return {
    props: {
      pageTranslations: blogDataTranslation,
      headerTranslation: headerDataTranslation,
      footerTranslation: footerDataTranslation,
      featuredBlogs,
      allPosts
    },
    revalidate: 300
  }
}

const Blog = ({
  headerTranslation,
  footerTranslation,
  pageTranslations,
  featuredBlogs,
  allPosts
}) => {
  const router = useRouter()
  return (
    <Page
      headerTranslation={headerTranslation}
      footerTranslation={footerTranslation}
      meta={{
        title: pageTranslations.seo.title[router.locale],
        description: pageTranslations.seo.description[router.locale]
      }}
      footer={false}
    >
      <Welcome
        featuredBlogs={featuredBlogs}
        buttonLabel={pageTranslations.cards.button[router.locale]}
      />

      <Content
        blogs={allPosts}
        buttonLabel={pageTranslations.cards.button[router.locale]}
      />

      <Subscribe
        title={pageTranslations.subscribe.title[router.locale]}
        description={pageTranslations.subscribe.description[router.locale]}
        translations={footerTranslation.form}
      />

      <SocialPromo title={pageTranslations.promo.title[router.locale]} />
    </Page>
  )
}

export default Blog
